<div class="helptext-wrapper no-print" [class.left]="left">
  <div class="helptext" [class.open]="open" [class.down]="down" [class.noopen]="!helptext"  (click)="toggleText()">
    @if (helptext) {
      <p [id]="helptextId" [innerHTML]="helptext | translate | safeHtml"></p>
    }
    <button type="button" [attr.aria-expanded]="open" [attr.aria-controls]="helptextId">{{buttontext | translate}}</button>
    <i [class]="icon"></i>
  </div>
</div>
